import { App } from 'vue'
import { useFeatureFlags } from '@/composables/useFeatureFlag.ts'

interface FeatureFlagsPluginOptions {
  loadOnInit?: boolean
  retryOnError?: boolean
  retryDelay?: number
  maxRetries?: number
  silent?: boolean
}

export default {
  async install(app: App, options: FeatureFlagsPluginOptions = {}) {
    const {
      loadOnInit = true,
      retryOnError = true,
      retryDelay = 2000,
      maxRetries = 3,
      silent = false
    } = options

    if (!silent) console.log('[featureFlags] Installing plugin...')

    const featureFlags = useFeatureFlags()

    const initWithRetry = async () => {
      let attempt = 0
      while (attempt < maxRetries) {
        try {
          await featureFlags.init()
          if (!silent) console.log('[featureFlags] Initialized successfully')
          return
        } catch (error) {
          attempt++
          console.error(`[featureFlags] Init attempt ${attempt} failed:`, error)
          if (!retryOnError || attempt >= maxRetries) {
            console.warn('[featureFlags] Initialization aborted')
            return
          }
          await new Promise(resolve => setTimeout(resolve, retryDelay))
        }
      }
    }

    if (loadOnInit) {
      await initWithRetry()
    }

    app.provide('featureFlags', featureFlags)
    app.config.globalProperties.$featureFlags = featureFlags

    if (!silent) console.log('[featureFlags] Plugin installed')
  }
}
